import { createBrowserRouter } from "react-router";
import NotFoundPage from "./pages/NotFoundPage";
import Login from "./pages/Login";
import Layout from "./Layout";
import ContractsView from "./pages/contracts/ContractsView";
import SettingsPage from "./pages/settings/SettingsPage";
import ForwardingView from "./pages/forwarding/ForwardingView";
import TransportOrdersView from "./pages/transportOrders/TransportOrdersView";
import DeliveriesView from "./pages/deliveries/DeliveriesView";
import GoodsToTakeAwayView from "./pages/goodsToTakeAway/GoodsToTakeAwayView";
import DriversPage from "./pages/drivers/DriversPage";
import LocationsPage from "./pages/locations/LocationsPage";
import CompaniesPage from "./pages/companies/CompaniesPage";
import ProductsPage from "./pages/products/ProductsPage";

export const router = createBrowserRouter([
  {
    path: "/",
    Component: Login,
  },
  {
    Component: Layout,
    children: [
      {
        path: "kontrakty",
        Component: ContractsView,
      },
      {
        path: "towar-do-zabrania",
        Component: GoodsToTakeAwayView,
      },
      {
        path: "zlecenia-transportowe",
        Component: TransportOrdersView,
      },
      {
        path: "spedycja",
        Component: ForwardingView,
      },
      {
        path: "dostawy",
        Component: DeliveriesView,
      },
      {
        path: "kierowca",
        Component: DriversPage,
      },
      {
        path: "firmy",
        Component: CompaniesPage,
      },
      {
        path: "lokalizacje",
        Component: LocationsPage,
      },
      {
        path: "towar",
        Component: ProductsPage,
      },
      {
        path: "ustawienia",
        Component: SettingsPage,
      },
      { path: "*", Component: NotFoundPage },
    ],
  },
]);
